export var sl;
(function (sl) {
    sl.names = {
        AD: "Andora",
        AE: "Združeni arabski emirati",
        AF: "Afganistan",
        AG: "Antigva in Barbuda",
        AI: "Angvila",
        AL: "Albanija",
        AM: "Armenija",
        AO: "Angola",
        AQ: "Antarktika",
        AR: "Argentina",
        AS: "Ameriška Samoa",
        AT: "Avstrija",
        AU: "Avstralija",
        AW: "Aruba",
        AX: "Ålandski otoki",
        AZ: "Azerbajdžan",
        BA: "Bosna in Hercegovina",
        BB: "Barbados",
        BD: "Bangladeš",
        BE: "Belgija",
        BF: "Burkina Faso",
        BG: "Bolgarija",
        BH: "Bahrajn",
        BI: "Burundi",
        BJ: "Benin",
        BL: "Saint Barthélemy",
        BM: "Bermudi",
        BN: "Brunej",
        BO: "Bolivija",
        BQ: "Nizozemski Karibi",
        BR: "Brazilija",
        BS: "Bahami",
        BT: "Butan",
        BV: "Bouvetov otok",
        BW: "Bocvana",
        BY: "Belorusija",
        BZ: "Belize",
        CA: "Kanada",
        CC: "Kokosovi otoki",
        CD: "Demokratična republika Kongo",
        CF: "Centralnoafriška republika",
        CG: "Kongo - Brazzaville",
        CH: "Švica",
        CI: "Slonokoščena obala",
        CK: "Cookovi otoki",
        CL: "Čile",
        CM: "Kamerun",
        CN: "Kitajska",
        CO: "Kolumbija",
        CR: "Kostarika",
        CU: "Kuba",
        CV: "Zelenortski otoki",
        CW: "Curaçao",
        CX: "Božični otok",
        CY: "Ciper",
        CZ: "Češka",
        DE: "Nemčija",
        DJ: "Džibuti",
        DK: "Danska",
        DM: "Dominika",
        DO: "Dominikanska republika",
        DZ: "Alžirija",
        EC: "Ekvador",
        EE: "Estonija",
        EG: "Egipt",
        EH: "Zahodna Sahara",
        ER: "Eritreja",
        ES: "Španija",
        ET: "Etiopija",
        FI: "Finska",
        FJ: "Fidži",
        FK: "Falklandski otoki",
        FM: "Mikronezija",
        FO: "Ferski otoki",
        FR: "Francija",
        GA: "Gabon",
        GB: "Združeno kraljestvo",
        GD: "Grenada",
        GE: "Gruzija",
        GF: "Francoska Gvajana",
        GG: "Guernsey",
        GH: "Gana",
        GI: "Gibraltar",
        GL: "Grenlandija",
        GM: "Gambija",
        GN: "Gvineja",
        GP: "Gvadalupe",
        GQ: "Ekvatorialna Gvineja",
        GR: "Grčija",
        GS: "Južna Georgia in Južni Sandwichevi otoki",
        GT: "Gvatemala",
        GU: "Guam",
        GW: "Gvineja Bissau",
        GY: "Gvajana",
        HK: "Hongkong",
        HM: "Heardov otok in McDonaldovi otoki",
        HN: "Honduras",
        HR: "Hrvaška",
        HT: "Haiti",
        HU: "Madžarska",
        ID: "Indonezija",
        IE: "Irska",
        IL: "Izrael",
        IM: "Otok Man",
        IN: "Indija",
        IO: "Britansko ozemlje v Indijskem oceanu",
        IQ: "Irak",
        IR: "Iran",
        IS: "Islandija",
        IT: "Italija",
        JE: "Jersey",
        JM: "Jamajka",
        JO: "Jordanija",
        JP: "Japonska",
        KE: "Kenija",
        KG: "Kirgizistan",
        KH: "Kambodža",
        KI: "Kiribati",
        KM: "Komori",
        KN: "Saint Kitts in Nevis",
        KP: "Severna Koreja",
        KR: "Južna Koreja",
        KW: "Kuvajt",
        KY: "Kajmanski otoki",
        KZ: "Kazahstan",
        LA: "Laos",
        LB: "Libanon",
        LC: "Saint Lucia",
        LI: "Lihtenštajn",
        LK: "Šrilanka",
        LR: "Liberija",
        LS: "Lesoto",
        LT: "Litva",
        LU: "Luksemburg",
        LV: "Latvija",
        LY: "Libija",
        MA: "Maroko",
        MC: "Monako",
        MD: "Moldavija",
        ME: "Črna gora",
        MF: "Saint Martin",
        MG: "Madagaskar",
        MH: "Marshallovi otoki",
        MK: "Makedonija",
        ML: "Mali",
        MM: "Mjanmar (Burma)",
        MN: "Mongolija",
        MO: "Macao",
        MP: "Severni Marianski otoki",
        MQ: "Martinik",
        MR: "Mavretanija",
        MS: "Montserrat",
        MT: "Malta",
        MU: "Mauritius",
        MV: "Maldivi",
        MW: "Malavi",
        MX: "Mehika",
        MY: "Malezija",
        MZ: "Mozambik",
        NA: "Namibija",
        NC: "Nova Kaledonija",
        NE: "Niger",
        NF: "Norfolški otok",
        NG: "Nigerija",
        NI: "Nikaragva",
        NL: "Nizozemska",
        NO: "Norveška",
        NP: "Nepal",
        NR: "Nauru",
        NU: "Niue",
        NZ: "Nova Zelandija",
        OM: "Oman",
        PA: "Panama",
        PE: "Peru",
        PF: "Francoska Polinezija",
        PG: "Papua Nova Gvineja",
        PH: "Filipini",
        PK: "Pakistan",
        PL: "Poljska",
        PM: "Saint Pierre in Miquelon",
        PN: "Pitcairn",
        PR: "Portoriko",
        PS: "Palestinsko ozemlje",
        PT: "Portugalska",
        PW: "Palau",
        PY: "Paragvaj",
        QA: "Katar",
        RE: "Reunion",
        RO: "Romunija",
        RS: "Srbija",
        RU: "Rusija",
        RW: "Ruanda",
        SA: "Saudova Arabija",
        SB: "Salomonovi otoki",
        SC: "Sejšeli",
        SD: "Sudan",
        SE: "Švedska",
        SG: "Singapur",
        SH: "Sveta Helena",
        SI: "Slovenija",
        SJ: "Svalbard in Jan Mayen",
        SK: "Slovaška",
        SL: "Sierra Leone",
        SM: "San Marino",
        SN: "Senegal",
        SO: "Somalija",
        SR: "Surinam",
        SS: "Južni Sudan",
        ST: "Sao Tome in Principe",
        SV: "Salvador",
        SX: "Sint Maarten",
        SY: "Sirija",
        SZ: "Svazi",
        TC: "Otoki Turks in Caicos",
        TD: "Čad",
        TF: "Francosko južno ozemlje",
        TG: "Togo",
        TH: "Tajska",
        TJ: "Tadžikistan",
        TK: "Tokelau",
        TL: "Timor-Leste",
        TM: "Turkmenistan",
        TN: "Tunizija",
        TO: "Tonga",
        TR: "Turčija",
        TT: "Trinidad in Tobago",
        TV: "Tuvalu",
        TW: "Tajvan",
        TZ: "Tanzanija",
        UA: "Ukrajina",
        UG: "Uganda",
        UM: "Stranski zunanji otoki Združenih držav",
        US: "Združene države Amerike",
        UY: "Urugvaj",
        UZ: "Uzbekistan",
        VA: "Vatikan",
        VC: "Saint Vincent in Grenadine",
        VE: "Venezuela",
        VG: "Britanski Deviški otoki",
        VI: "Ameriški Deviški otoki",
        VN: "Vietnam",
        VU: "Vanuatu",
        WF: "Wallis in Futuna",
        WS: "Samoa",
        XK: "Kosovo",
        YE: "Jemen",
        YT: "Mayotte",
        ZA: "Južnoafriška republika",
        ZM: "Zambija",
        ZW: "Zimbabv",
    };
})(sl || (sl = {}));
//# sourceMappingURL=sl.js.map